export default "__VITE_PUBLIC_ASSET__e6e7143e__"